<template>
  <v-dialog v-model="dialog" :retain-focus="false" width="500">
     <template v-slot:activator="{on, attrs}">
        <v-btn :class="btn_classes" :color="color" v-bind="attrs" v-on="on">
          <v-icon>{{ btn_icon }}</v-icon>
          {{ btn_text }}
        </v-btn>
     </template>
     <v-card>
        <v-card-title>{{ title }}</v-card-title>
        <v-card-text>
          <slot name="body">
          </slot>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="dialog=false">Отмена</v-btn>
          <v-btn text @click.stop="onSubmit"><v-icon>{{ btn_icon }}</v-icon>{{ btn_text }}</v-btn>
        </v-card-actions>
     </v-card>
 </v-dialog>
</template>

<script>
export default{
  props:{
    title: String,
    btn_icon: String,
    btn_text: {
      type: String, 
      default: ''
    },
    btn_classes: [Array, String],
    color: String
  },
  data: ()=>({
    dialog: false
  }),
  methods:{
      onSubmit(){
        this.$emit('onSubmit')
        this.dialog = false
      }
  }
}
</script>